import { Button, QRCode, Space, Typography } from "antd";
import type { TourStepConfig } from "../types";

export const telegramTourSteps: TourStepConfig[] = [
  {
    title: "Подключите Telegram-бот",
    description: (
      <Space orientation="vertical" size="middle" style={{ width: "100%" }}>
        <Typography.Paragraph>
          Подключив бот <strong>@aismetrica_bot</strong>, вы сможете:
        </Typography.Paragraph>
        <ul style={{ paddingInlineStart: 20, margin: 0 }}>
          <li>
            Получать <strong>коды подтверждения</strong> для входа прямо в Telegram
          </li>
          <li>
            Общаться с <strong>техподдержкой</strong> — как в системе, так и в удобном мессенджере
          </li>
          <li>
            Получать <strong>уведомления и отчёты</strong> прямо в чат
          </li>
          <li>
            Запрашивать <strong>данные из системы</strong> через бот
          </li>
        </ul>
        <QRCode value="https://t.me/aismetrica_bot" size={180} />
        <Button type="primary" href="https://t.me/aismetrica_bot" target="_blank" block>
          Открыть @aismetrica_bot
        </Button>
        <Typography.Text type="secondary">
          Нажмите /start в боте для привязки аккаунта
        </Typography.Text>
      </Space>
    ),
    placement: "center",
  },
  {
    title: "Поддержка всегда рядом",
    description:
      "Нажмите эту кнопку, чтобы написать в поддержку прямо из системы. " +
      "Если вы подключили Telegram — ответы придут и туда.",
    tourTargetId: "support-float-button",
    placement: "left",
  },
];
